 export const InitialState = {
    type: null,
    points: null,
    panelistId: null,
  };